import agreement1 from '@/locales/Terms/FranchiseAgreement/US/agreement1.html';
import agreement2 from '@/locales/Terms/FranchiseAgreement/US/agreement2.html';
import agreement3 from '@/locales/Terms/FranchiseAgreement/US/agreement3.html';
import agreement4 from '@/locales/Terms/FranchiseAgreement/US/agreement4.html';
import agreement5 from '@/locales/Terms/FranchiseAgreement/US/agreement5.html';
import agreement6 from '@/locales/Terms/FranchiseAgreement/US/agreement6.html';
import agreement7 from '@/locales/Terms/FranchiseAgreement/US/agreement7.html';
import agreement8 from '@/locales/Terms/FranchiseAgreement/US/agreement8.html';
import agreement9 from '@/locales/Terms/FranchiseAgreement/US/agreement9.html';
import agreement10 from '@/locales/Terms/FranchiseAgreement/US/agreement10.html';
import agreement11 from '@/locales/Terms/FranchiseAgreement/US/agreement11.html';
import agreement12 from '@/locales/Terms/FranchiseAgreement/US/agreement12.html';
import agreement13 from '@/locales/Terms/FranchiseAgreement/US/agreement13.html';
import guideline1 from '@/locales/Terms/Guideline/US/guideline1.html';
import guideline2 from '@/locales/Terms/Guideline/US/guideline2.html';
import legal_indication1 from '@/locales/Terms/LegalIndication/US/legal_indication1.html';
import legal_indication2 from '@/locales/Terms/LegalIndication/US/legal_indication2.html';
import legal_indication3 from '@/locales/Terms/LegalIndication/US/legal_indication3.html';
import legal_indication4 from '@/locales/Terms/LegalIndication/US/legal_indication4.html';
import legal_indication5 from '@/locales/Terms/LegalIndication/US/legal_indication5.html';
import legal_indication6 from '@/locales/Terms/LegalIndication/US/legal_indication6.html';
import legal_indication7 from '@/locales/Terms/LegalIndication/US/legal_indication7.html';
import legal_indication8 from '@/locales/Terms/LegalIndication/US/legal_indication8.html';
import privacy_policy1 from '@/locales/Terms/PrivacyPolicy/US/privacy_policy1.html';
import privacy_policy2 from '@/locales/Terms/PrivacyPolicy/US/privacy_policy2.html';
import privacy_policy3 from '@/locales/Terms/PrivacyPolicy/US/privacy_policy3.html';

// New UI translation
import new_ui from '@/locales/NewUI';

export default {
	locale_order: 2,
	locale_name: 'English',
	terms: {
		title: 'JPWORLDPAY Terms of Service',
		agreement1,
		agreement2,
		agreement3,
		agreement4,
		agreement5,
		agreement6,
		agreement7,
		agreement8,
		agreement9,
		agreement10,
		agreement11,
		agreement12,
		agreement13,
		guideline1,
		guideline2,
		legal_indication1,
		legal_indication2,
		legal_indication3,
		legal_indication4,
		legal_indication5,
		legal_indication6,
		legal_indication7,
		legal_indication8,
		privacy_policy1,
		privacy_policy2,
		privacy_policy3,
		menu: {
			category1: 'The Franchise Agreement',

			title1: 'Merchant Terms and Conditions (for online payment)',
			title2: 'Online payment API Usage Special Agreement',
			title3: 'Balance Terms and Conditions (for online payment)',
			title4:
				'Credit Card Merchant Terms and Conditions (for mail-order merchants)',
			title5:
				'JPWORLDPAY for Business Terms and Conditions (for online payment)',
			title6: 'Postpaid Merchant Terms and Conditions (for online payment)',
			title7: 'Data Usage Special Agreement',
			title8: 'Special Agreement on Payment for Products, etc.',
			title9: 'Special Agreement on the Handling of prepaid services',
			title10: 'Merchant Terms and Conditions (for mini-app)',
			title11: 'Data Use Special Agreement (for mini app)',
			title12: 'The establishment of a contract',
			title13: 'About Joint Use of Merchant Information',
			category2: 'The Guideline',
			title14: 'Merchant Guidelines (for Mini-app)',
			title15: 'Merchant Guidelines (for online payments)',
			category3: 'Legal Indication',
			title16: 'Banking Agent Overview',
			title17: 'Handling product card loan individual interest rate, etc',
			title18: 'Handling product Card loan Individual product brief',
			title19: 'Yen ordinary deposit account interest rate, etc',
			title20: 'Yen ordinary deposit account product overview',
			title21: 'Handling product business loan interest rate, etc',
			title22: 'Handling product Business loan Product brief',
			title23:
				'About the applicable interest rate in case of multiple contracts with the Company',
			category4: 'Privacy Policy',
			title24: 'Request for disclosure of personal information',
			title25: 'About User Security',
			title26: 'Affiliated company',
		},
	},
	cookies: {
		title: 'Cookies Usage Policy',
		text1:
			'JPWORLDPAY uses cookies to anonymously collect search information from website users to obtain sources and other statistics.',
		text2:
			"Cookies are tiny text files on your computer's hard disk, for example, for recording the process of purchasing a product, search propensity, activity, and so on.",
		text3: 'In particular, it is used as follows:',
		text4:
			'Google Analytics. Google can use this information to improve its services and provide services to third parties.',
		text5: 'All information can be accessed via the following link.',
		text6: 'Protect data',
		text7: 'Analytics Blocking Browser Add-On',
		text8:
			'The tool does not collect your name, address, and access information. The information about users collected is related to, for example, the number of access sites, the language of use, the city displayed by the user IP, the number of visitors, the number of revisits, the time of access, the browser, operator, or terminal type used. The above information is used to identify new requirements and to provide better website service to users through evaluation of improvement efforts.',
		text9:
			'Cookies used on social networks. This website has a social network button installed to allow users to share their content of interest with social groups. Cookies stored through social networks prevent the inconvenience of re-entering personal information in sharing the above content.',
		text10:
			'Tools options in the web browser installed on your computer allow you to allow/disallow all cookies, delete them, or go through verification whenever cookies are saved.',
		text11:
			'You can find functional information for each web browser you use at the link below:',
		text12: 'Firefox',
		text13: 'Chrome',
		text14: 'Safari',
	},
	rtr_footer: {
		text1: 'つなぎ . 無断転載を禁じます',
	},
	rtr_home: {
		text1: 'Do you still think it is',
		text2: 'impossible to pay with',
		text3: 'cryptographic assets?',
		text4:
			'Payments can be made immediately without exchanging cryptographic assets',
		button1: 'Cryptographic assets pay immediately',
		text5: 'JPWORLDPAY, safety and speed',
		text6: 'at the same time',
		text7: 'Meet the fastest payment system with the stability',
		text8: "of the blockchain and JPWORLDPAY's unique technology.",
		text9: 'Sign Up',
		text10: 'We offer it',
		text11: 'for free.',
		text12: 'The best technology, the best service, and the best platform',
		text13: 'but JPWORLDPAY is free.',
		text14: 'How to create a free account',
		text15: 'With JPWORLDPAY, there are',
		text16: 'so many advantages.',
		text17: "JPWORLDPAY doesn't need a credit card.",
		text18: 'As long as you’re connected to wifi network,',
		text19: 'you can use JPWORLDPAY anywhere.',
		text20: 'You can pay immediately through QR code.',
		text21: 'You can also pay offline through',
		text21_1: 'kiosks and POS machines.',
		text22: 'How to shop and pay',
		text23: 'JPWORLDPAY Payment',
		text24: 'Pay anywhere',
		text25: 'QR code Payment',
		text26: 'Easy payment with QR code',
		text27: 'Kiosk and POS Machine',
		text28: 'Convenient offline payment',
		text29: 'It can be used anywhere in the world.',
		text30: 'Anyone can use it and it can be used anywhere.',
		text31: 'JPWORLDPAY knows the biggest attraction of cryptographic assets.',
		text32:
			"We're trying to be a guide to telling the world how to use cryptographic assets.",
		button2: 'Getting Started for Free',
		text33: 'Even business members',
		text34: 'can use for free.',
		text35: 'Are you looking for ways to expand your business?',
		text36: 'Do you still pay with currency pair?',
		text37:
			"Get paid with cryptographic assets used by the world's population.",
		text38: 'Opening a business store',
		text39: 'We',
		text40: 'hear your voice.',
		text41: 'JPWORLDPAY always listens to customer’s',
		text42: 'and practices them.',
		text43: 'Q&A',
	},
	'rtr_personal-how-online_shopping': {
		title1: 'Pay with JPWORLDPAY',
		text1: 'Add the cryptocurrency you want and',
		text2: 'experience shopping flexibly wherever you want.',
		text3: 'cryptocurrency that is only in your electronic wallet',
		text4: 'JPWORLDPAY ',
		text5: 'through',
		text6: 'Enjoy shopping anywhere with.',
		text7: 'Make a cryptocurrency',
		text8: 'wallet that you want in JPWORLDPAY.',
		text9: 'Please choose',
		text10: 'JPWORLDPAY when you are shopping.',
		text11: 'Pay with the cryptocurrency',
		text12: 'you want on JPWORLDPAY.',
		title2: 'We hope you',
		title3: 'enjoy it again.',
		text13: 'Please buy with JPWORLDPAY,',
		text14: 'get points and then buy again.',
		text15: 'JPWORLDPAY points are available',
		text16: 'at all Merchants using JPWORLDPAY.',
		title4: 'Pay',
		title5: 'without worrying.',
		text17: "JPWORLDPAY's security is the best in the world.",
		text18: 'We keep your cryptocurrency and assets safe and',
		text19: 'help you use them safely.',
	},
	'rtr_personal-how-offline_kiosk': {
		title1: 'How to use',
		title2: 'offline merchants',
		text1: 'Customers can quickly make payments themselves.',
		text2: 'Please try JPWORLDPAY, which allows you to pay immediately with a',
		text3: 'mobile phone without cash or card.',
		text4: 'JPWORLDPAY ',
		text5: 'Payment method using',
		text6: 'Select JPWORLDPAY',
		text7: 'on your phone and use it.',
		text8: 'Select your wallet',
		text9: 'and then select the Offline Store Payment.',
		text10: 'If you scan the QR code on the kiosk,',
		text11: 'the payment is complete.',
		text12: 'Welcome to the ',
		text13: 'future currency system.',
		text14: 'Secure Payment',
		text15:
			'Your information will not be remembered when you make an offline payment.',
		text16: 'At a nearby merchants',
		text17: 'Find merchants with JPWORLDPAY anytime, anywhere and use it.',
		text18: 'Without cash',
		text19: 'Do you still carry cash? Use JPWORLDPAY on your phone right away.',
		title3: 'Sellers can',
		title4: 'access easily too.',
		text20:
			'All you have to do is register the items for sale at the JPWORLDPAY kiosk.',
		text21: 'The payment will be made by JPWORLDPAY Kiosk.',
	},
	'rtr_personal-how-qr': {
		title1: 'Pay at your go-to store',
		title2: 'with JPWORLDPAY.',
		text1: 'Paying directly is as easy as scanning QR codes',
		text2: 'when paying and does not require touch.',
		text3: "You don't have to carry cards or cash, just use the app.",
		text4: 'Welcome to the future currency system.',
		text5: 'Secure Payment',
		text6: 'JPWORLDPAY does not disclose your',
		text7: 'information during QR code transactions.',
		text8: 'Any company',
		text9: 'Pay at the',
		text10: 'offline merchants anywhere,',
		text11: '24 hours a day.',
		text12: 'Touch-free, no cash',
		text13: "Don't worry about cash or",
		text14: 'credit card- open the application and pay.',
		text15: '3-steps payment with QR code',
		text16: 'You need JPWORLDPAY',
		text17: 'app and account.',
		text18: 'STEP 01. Scan or Show',
		text19: 'STEP 02. Payment',
		text20: 'STEP 03. Confirm',
		text21: 'Tap the QR iPhone,',
		text22: 'select Scan when the seller presents the code,',
		text23: 'or tap Show to pay if you are requesting a QR code.',
		text24: 'Scan the code when the QR code is displayed',
		text25:
			'Once you receive the payment confirmation, all payments will be completed.',
		title3: 'Prepare for sale',
		title4: 'with QR code.',
		text26: 'Whether you start or run your business,',
		text27: 'you can easily accept touch-free face-to-face payments',
		text28: 'without hardware, software or card readers.',
		text29: 'STEP 01.',
		text30: 'Scan or Show',
		text31: 'STEP 02.',
		text32: 'Payment',
		text33: 'STEP 03.',
		text34: 'Confirm',
	},
	'rtr_personal-how-janopay_creditcard': {
		title1: 'JPWORLDPAY card',
		text1: 'You can easily access your JPWORLDPAY balance',
		text2: 'with debit and prepaid cards or fund your daily purchases',
		text3: 'with one of your credit offerings.',
		title2: 'JPWORLDPAY Credit',
		title3: 'Buy now and pay over time.',
		text4: 'Get special financing for purchases over',
		text5: '10,000 yen wherever JPWORLDPAY is allowed.',
		text6: 'There is no interest if you pay the',
		text7: 'full amount within 6 months for every 10,000 yen purchase.',
		text8: 'If you do not pay your balance in full within six months,',
		text9:
			'interest will be charged to your account from the date of purchase.',
		text10: 'A minimum monthly payment is required. Subject to credit approval',
		// text11: '쇼핑 및 구매방법',
		text12: 'Available wherever',
		text13: 'JPWORLDPAY is allowed',
		text14: 'No annual fee',
		text15: 'JPWORLDPAY Coin Access',
		text16: 'from your JPWORLDPAY account',
		title4: 'NEW',
		title5: 'JPWORLDPAY Cashback',
		text17: 'Unlimited 3% cashback when purchasing JPWORLDPAY',
		text18: 'Get unlimited 2% for all other purchases.',
		text19: 'Be the first to find out when you can use it.',
		text20: 'Previous 2% cashback holders do not need to join the list.',
		text21: 'You will receive an automatic upgrade.',
		title6: 'JPWORLDPAY Cash Card',
		text22: 'You can easily manage ',
		text23: 'your funds by accessing them with a',
		text24: 'debit card connected to your JPWORLDPAY balance.',
		text25: 'JPWORLDPAY Cash Card Information',
		text26: 'Learn about JPWORLDPAY Credits',
		text27: 'View Terms and Conditions',
	},
	'rtr_personal-how-trade_and_cashback': {
		title1: 'You can get',
		title2: 'additional rewards by using JPWORLDPAY.',
		text1: 'Save money by transactions,',
		text2: 'cashback offers and promotional code',
		text3: 'and get rewards from the best stores and your favorite brands.',
		title3: 'Trade in cryptocurrency that suits me',
		text4: 'We will showcase deals, products and',
		text5: 'stores you think you will like based on where you shop and buy,',
		text6:
			'and we promise to continue to increase and update your favorite stores.',
		title4: 'Maximize your rewards',
		title5: 'Maximize rewards',
		text7: 'Combining transactions, cashback suggestions and',
		text8: 'promotional code can save you more money.',
		text9: 'We will help you find and apply promotion codes',
		text10: 'when you pay.',
		text11: 'Does JPWORLDPAY card offer a reward?',
		text12: 'Check out for your purchase and use it to get a reward.',
		text13: 'Start shopping',
		title6: 'Secure checkout',
		text14:
			'Utilize transaction and cashback offers from millions of global retailers',
		text15: 'when making payments securely with JPWORLDPAY.',
		text16: 'Your information is encrypted and',
		text17: 'will not be sold or shared without your permission.',
		text18: 'Learn how to protect yourself',
	},
	'rtr_personal-request-send': {
		title1: 'A safe and fun way to',
		title2: 'remittance online',
		text1: "It's a simple way to quickly remit money to family and",
		text2: 'friends from almost anywhere in the world.',
		text3: 'Get the most out of all transfers',
		text4: 'Two-way messages',
		text5: 'Exchange messages to check if',
		text6: 'the payment is correctly',
		text7: 'made between friends.',
		text8: 'Free Options',
		text9: 'After you use the ',
		text10: "JPWORLDPAY point card and check it's balance,",
		text11: 'you can remit money online from overseas.',
		text12: 'Quick Access',
		text13: 'The recipient can',
		text14: 'get the money without delay',
		text15: 'when remitting cryptocurrency.',
		title4: 'Year-Round Monitoring',
		text16: 'With encryption technology, we do our best to',
		text17: 'ensure that your transfer is safe.',
		title5: 'Transfer Worldwide',
		text18: 'Transfer money to your recipient anywhere',
		text19: 'in the world with JPWORLDPAY.',
		text20: 'Transfer money online to friends and family anywhere in the world',
		text21: '0 JPYS',
		text22: 'Transaction fee in JPWORLDPAY',
		text23: 'When withdrawing from wallets from other banks,',
		text24: '0% if money is sent from JPWORLDPAY balance.',
	},
	'rtr_personal-request-receive': {
		title1: 'request conveniently',
		text1: 'Friends and family can',
		text2: 'request cryptocurrency without notification.',
		title2: 'Convenient Asset Request Service',
		text3: 'Convenient, easy-to-use requests',
		text4: 'Instant two-way messaging',
		title3: 'Free request',
		title4: 'service without hassle',
		text5: 'Once you request money from your friends and',
		text6: 'then wait, money will be deposited automatically.',
		title5: 'Easy Settings',
		text7: "If your friend doesn't have a JPWORLDPAY account",
		text8: 'only have to do is sign up in a few minutes.',
		text9: "It's easy to send salaries.",
		text10: 'Open the app and select Receive Payment.',
		title6: 'Select a JPWORLDPAY user and',
		title7: 'enter the requested amount.',
		title8: 'Secure checkout',
		text11: 'You can simplify the daily reception of cryptocurrency by',
		text12: 'instantly creating a link to request assets of JPWORLDPAY.',
		text13: 'Creating a JPWORLDPAY Link',
	},
	'rtr_personal-request-deposit': {
		text1: 'Receive deposit',
		text2: 'JPWORLDPAY receive your deposits conveniently at .',
		text3: 'The most convenient deposit',
		text4: 'Just send it to the other persons email and you are done.',
		text5: 'What the recipient sees',
		text6: 'JPWORLDPAY and',
		text7: 'JPWORLDPAY remittance between people',
		text8: 'JPWORLDPAY at JPWORLDPAY When sending money to',
		text9: 'The account number used will be exposed.',
		text10: 'From outside',
		text11: 'JPWORLDPAY deposit by',
		text12: 'When depositing to JPWORLDPAY from outside',
		text13: 'The wallet address used is exposed.',
	},
	'rtr_personal-request-commission': {
		text1: 'Free transfer fee',
		text2: 'JPWORLDPAY no fees for transfers between countries!',
		text3: 'When depositing to an external wallet',
		text4: 'Network cost only',
		text5: 'Upon deposit JPWORLDPAY In',
		text6: 'We do not request payment of fees.',
		text7: 'Within our platform',
		text8: 'Movement is free.',
		text9: 'Fees only apply when withdrawing money externally',
		text10: 'JPWORLDPAYNo fees when purchasing using',
	},
	'rtr_personal-asset-wallet': {
		text1: 'Use of international standard wallets',
		text2: 'Secure your own wallet with security',
		text3:
			'We use a wallet developed with our own technology, not an external wallet company.',
		text4: 'In line with international standards',
		text5: 'LEVEL 2 more security',
		text6: 'Lets be more careful about security',
		text7: 'Completely blocks hacking.',
		text8: 'Private key',
		text9: 'It doesnt happen.',
		text10: 'Administrator and DB Even if hacking comes in',
		text11: 'It is difficult to hack because there is no private key.',
		text12: 'What is a wallet?',
		text13: 'Its like your safe.',
		text14: 'Us JPWORLDPAY after creating your own wallet,',
		text15:
			'It is a wallet that has been repeatedly secured, so it is resistant to hacking.',
		text16: 'Optimized for security, so you can be confident in your security.',
	},
	'rtr_personal-asset-account': {
		text1: 'JPWORLDPAY Independent seat system',
		text2: 'It is like putting a metal door on the door.',
		text3: 'JPWORLDPAY Take advantage of the entrance and exit.',
		text4: 'Independent seating system',
		text5: 'Sooner',
		text6: 'JPWORLDPAY From JPWORLDPAY Sending money to the table at the time',
		text7: '1~3 Enter the door and move the door.',
		text8: 'Let’s go and see.',
		text9: 'Creating a money sending system',
		text10: 'Used the seat JPWORLDPAY From JPWORLDPAY Sending time',
		text11: 'No matter how many times you move, you can see all the time.',
		text12: 'JPWORLDPAY In the morning',
		text13: 'Let’s go together.',
	},
	'rtr_personal-asset-jpys': {
		text1: 'JPYS Own point system',
		text2: 'Fast and secure self-point system',
		text3: 'No more fatigue with fixed exchange rates.',
		text4: 'Linked with all systems',
		text5: 'Offline stores and online stores',
		text6: 'JPYS All you need is one.',
		text7: 'Kiosks and POS machines',
		text8: 'Pay freely anywhere',
		text9: 'Convenient charging',
		text10: 'With your desired cryptocurrency and credit card',
		text11: 'Can be recharged immediately',
	},
	'rtr_personal-asset-sale': {
		title1: 'Sell',
		text1: 'Is it difficult to sell crypto assets?',
		text2: 'Are you still waiting for a buyer?',
		title2: 'Crypto asset sales price',
		title3: 'It just got so easy.',
		text3: 'Sales between customers',
		text4: 'Customer directly JPWORLDPAY sold on',
		text5: 'Sell ​​your way',
		title4: 'with one button',
		title5: 'Exchange rate applied automatically',
		text6: 'Current prices with a single click of a button',
		text7: 'It is automatically applied and can be sold immediately.',
	},

	'rtr_development-development': {
		text1: 'various payments',
		text2: 'linked quickly',
		text3: 'convenient',
		text4: 'Learn more',
	},

	'rtr_development-developmain': {
		text1: 'Payment',
		text2: 'Payment system using JPWORLDPAY API',
		text3: 'join the membership',
		text4: 'Please sign up for membership on the JPWORLDPAY homepage.',
		text5: 'log in',
		text6: 'All JPWORLDPAY services can be used after logging in.',
		text7: 'Merchant registration',
		text8:
			'You can register your affiliate store in the affiliate menu. Please enter your affiliate store name and ID.',
		text9: 'API Issuance',
		text10: 'Easy payment',
		text11: 'You can use it conveniently with the JPWORLDPAY payment system.',
		text12: 'Payment',
		text13: 'Merchant registration',
		text14: 'Easy payment',
		text21: 'Required parameters',
		text22: 'Tab',
		text23: 'Tab',
		text24: 'Tab',
		text25: 'Merchant Name',
		text26: 'seller',
		text27: 'Label',
		text28: 'Label',
		text29: 'Label',
		text30: 'Merchant ID',
		text31: 'seller',
		text32: 'Label',
		text33: 'Label',
		text34: 'Label',
		text35: 'Step 01',
		text17: 'Lorem Ipsum Lorem Ipsum',
		text18: 'Lorem Ipsum Lorem Ipsum',
		text19: 'Lorem Ipsum Lorem Ipsum',
		text20: 'Title',
	},

	'rtr_personal-asset-exchange': {
		title1: 'Currency exchange like a bank',
		text1: 'sell and buy',
		text2: 'Are you still going around exchanging money?',
		title2: 'Exchange money and send money immediately',
		text3: 'Are you still having trouble buying and sending crypto assets?',
		text4: 'Use it like a bank. Transfer and withdraw money instantly.',
		title3: 'with one button',
		title4: 'Exchange your currency easily.',
		text5: 'Automatic exchange rate, automatic sales',
		text6: 'Too easy interface',
		title5: 'Any asset you want, anytime',
		text7: 'Exchange between crypto assets is also possible',
		text8: 'Crypto assets can also be converted into JPYS points',
	},
	'rtr_business-how-start': {
		title1: 'Getting Started',
		text1: 'Everything starts with a business account.',
		text2: 'Join over 30 million sellers who rely on JPWORLDPAY.',
		text3: 'Contact account specialist to get started.',
		title2: 'Easy Settings',
		text4: 'Inquiry.',
		text5: "We'll help you.",
		// text6: 'help@janopay.com',
		title3: 'Registration is free.',
		text7: 'You only need an email address and',
		text8: 'some basic information about your business.',
		text9: 'Join a business account',
		title4: 'Start Payment',
		text10:
			'Once you confirm your email address and company name and link your',
		text11: 'JPWORLDPAY account, you complete',
		text12: 'your first sales preparation.',
	},
	'rtr_business-how-receive': {
		title1: 'Accept online and',
		title2: 'Face-to-Face Payments',
		title3: 'Gain a competitive advantage',
		title4: 'Flexibility required by customers',
		title5: 'Connect with global buyers',
		title6: 'Accept Online Payment',
		title7: 'Online Checkout',
		title8: 'Invoice and Estimate',
		title9: 'Sale on Socials',
		title10: 'Online Cryptocurrency Payment System',
		title11: 'Accept Direct Payment',
		title12: 'Point of Sale',
		text1: 'Contact your account specialist to get started.',
		text2: 'We help small businesses to receive payments almost everywhere.',
		text3: 'Have customers pay later, sign up for a subscription,',
		text4: 'or use global or local payment options.',
		text5: 'Payments are accepted online or in stores',
		text6: 'with all cryptocurrencies.',
		text7: 'Make sure your customers',
		text8: 'pay the way they want and',
		text9: 'make payments quickly.',
		text10: 'Learn more about',
		text11: 'accepting payments online.',
		text12: 'Customers can use a variety of payment methods on a site,',
		text13: 'mobile or app as a single solution.',
		text14: 'More information about online checkout',
		text15: 'More information about subscription services.',
		text16:
			'You can encourage customers to pay by sending free custom invoices',
		text17: 'that are easy to pay.',
		text18: 'More information about issuing an invoice',
		text19: 'Receive payment using our JPWORLDPAY payment system',
		text20: 'on various social media platforms.',
		text21: 'Learn more about social sales',
		text22:
			'Our credit and online payment services allow you to accept online and',
		text23: 'in-store payments with most major cryptocurrencies.',
		text24: 'Have the customer pay while shopping themselves.',
		text25: 'here',
		text26: 'Find out how it works',
		text27: 'Manage JPWORLDPAY Settings business, the perfect POS solution,',
		text28:
			'by accepting all types of popular transactions and tracking sales.',
		text29: 'Learn more about JPWORLDPAY Settings',
	},
	'rtr_business-how-pay': {
		title1: 'Business Payment and Funding Access',
		title2: 'Purchase conveniently.',
		title3: 'If you just pay',
		title4: 'Payment',
		title5: 'Getting started today',
		text1: 'Simplify business transactions',
		text2: 'with us when you transfer, spend, and moving.',
		text3:
			'Do you need a highly customizable commercial solution for your business?',
		text4: 'Learn about JPWORLDPAY for business use.',
		text5: 'Use your JPWORLDPAY balance to',
		text6: 'pay for online and direct business fees.',
		text7: 'Save time and trouble sending funds electronically.',
		text8: 'Learn how to transfer',
		text9:
			'You can easily send it to multiple people and places simultaneously.',
		text10: 'Learn more about the sales money.',
		text11: 'Join a seller who relies on JPWORLDPAY.',
		text12: 'Join a business account',
		text13:
			'1. To maintain and use money with JPWORLDPAY, you must have a JPWORLDPAY business account or a JPWORLDPAY balance account.',
		text14:
			"2. Transactions that allow you to receive bonus cashback when you purchase 'JPWORLDPAY Business Debit BlockChain' are as follows. Credit transactions signed by you and processed by blockchain cards, cash withdrawals, transactions processed as cash services or using PINS for transactions with no cashback offers",
		text15:
			"'JPWORLDPAY Business Debit BlockChain' is issued by JPWORLDPAY.The card can be used wherever JPWORLDPAY is allowed. This is just the card issuer and is not responsible for any related accounts or other products, services or suggestions.",
	},
	'rtr_business-how-risk': {
		title1: 'For the mind of the',
		title2: 'customer and the consumer',
		title3: 'Rich Experience',
		title4: 'Transaction safely',
		title5: 'Fraud detection technology',
		text1: 'We can to protect our business using machine learning and',
		text2: "protect both our customers' assets and our consumers.",
		text3: 'Does your business need a highly customizable commerce solution?',
		text4: 'Learn about JPWORLDPAY for Business',
		text5:
			'Please use the trannsaction safely through JPWORLDPAY, which was created based on the',
		text6:
			'blockchain know-how that started from the beginning of the blockchain being known.',
		text7: "With the world's most secure blockchain,",
		text8: 'we can reach customers around the world.',
		text9: 'Our fraud detection tools get smarter with each transaction,',
		text10: 'protecting you from existing and evolving threats.',
	},
	'rtr_business-operation-corps': {
		title1: '기업에 관해',
		text1: '보안과 관리는 저희가 합니다.',
		text2: '운영에만 신경 쓰시면 됩니다.',
		title2: '가맹점 관리도 자동으로',
		text3: '아직도 일일이 관리를 하고 계신가요?',
		text4: 'JPWORLDPAY만 사용하면 자동으로',
		title3: '회원가입하고 가맹점 등록 끝',
		text5: '가맹점 관리 프로그램 무료.',
		text6: '사용료 없이 평생 무료 사용.',
	},
	'rtr_business-operation-platform': {
		title1: 'Platform and Features',
		text1: 'Optimized for business management.',
		text2: 'It is tailored solely for businesses.',
		title2: 'From franchise management',
		title3: 'Until accurate settlement',
		text3: 'Discover a platform optimized for your business.',
		title4: 'Intuitive and simple.',
		text4: 'When it comes to business, keep it as simple as possible.',
		title5: 'Even without learning',
		title6: 'Ready to use',
		text5: 'Keep the platform and features as simple as possible.',
		text6: 'So its easy for administrators to use.',
	},
	'rtr_business-operation-pay': {
		title1: 'Payment method',
		text1: 'Customers can pay at merchants using just their mobile phones.',
		title2: 'Paid to the merchant',
		title3: 'JPWORLDPAY Is',
		text2: 'Settlement by affiliate or settlement for all affiliates',
		title4: 'Settled JPWORLDPAY is fixed',
		title5: 'Withdrawal possible at any time.',
	},
	'rtr_business-operation-global': {
		title1: 'Global payment processing',
		text1:
			'JPWORLDPAY You can receive and withdraw to the country of your choice.',
		title2: 'Automatically applied to current exchange rate',
		text2: 'Withdraw money whenever you want.',
		title3: 'JPWORLDPAY Customers are in the country',
		title4: 'Payment is possible regardless.',
		title5: 'Why use cryptocurrency',
		text3:
			'The best reason is that you only need to look at the number of exchange rates.',
	},
	'rtr_business-asset-pay': {
		title1: 'JPWORLDPAY 가맹점 등록',
		text1: '고객이 지불한 페이는 등록된 가맹점 별로 정산',
		title2: '가맹점이 많아도',
		title3: '한번에 전체 정산',
		text2: '품목별까지 꼼꼼하게 놓치지 않고 정산됩니다.',
		title4: '언제든지',
		title5: '원하는 방식으로 지불',
		text3: '암호화폐로 지불할 수 있고',
		text4: '원하는 통화쌍으로 지불이 가능합니다.',
	},
	cs: {
		title: 'Customer Center',
		notice: 'Notice',
		inquiry: {
			inquiry: '1:1 Inquiry',
			list: 'Inquiry List',
			type: 'Inquiry Type',
			title: 'Title',
			date: 'Registration Date',
			status: 'Status',
			pending: 'Pending',
			complete: 'Complete',
			no_content: 'There is no inquiry.',
			text1: 'The inquiry you wrote',
			text2: 'has been received successfully',
			text3: 'received.',
		},
		faq: 'Frequently Asked Questions',
		ticket: {
			id: 'Ticket ID',
			text1: 'This is the ID required to check the answer to the inquiry.',
			text2: '문의내역 확인을 위해 PIN 코드를 입력하세요.',
			text3: 'Check inquiry details',
			text4: 'Please enter the ticket and',
			text5: 'password issued to you when inquiring.',
			input1: 'Please enter the Ticket ID',
			input2: 'Please enter your password.',
		},
		placeholder: {
			type: 'Please select inquiry type.',
			title: 'Please enter a title.',
			content: 'Please enter your inquiry.',
		},
	},
	'rtr_auth-login': {
		text1: 'Did you forget your ID/Password?',
	},
	'rtr_auth-find-account': {
		text1: 'Find ID',
		text2: 'Find Password',
		text3:
			'You can find it through the email you entered when you joined JPWORLDPAY.',
		text4:
			'You can find it through the ID and email you entered when you joined JPWORLDPAY.',
		text5: '비밀번호를 변경해 주세요.',
		placeholder1: 'Please enter the e-mail address.',
		placeholder2: 'Please enter ID',
		placeholder3: '인증번호를 입력해주세요.',
		placeholder4: '새 비밀번호를 입력해주세요.',
		placeholder5: '새 비밀번호 확인을 입력해주세요.',
	},
	'rtr_auth-register': {
		text1: 'Join JPWORLDPAY.',
		text2: 'which is used by countless people every day.',
		text3: 'Starting to sign up.',
		text4: 'Please accept the terms of service.',
		text5:
			'All consent includes consent for mandatory and optional items, and you can select individual items to agree to. The service is available even if you refuse to agree to optional items.',
		text6: 'Accept All',
		id: 'Please enter your ID.',
		email: 'Please enter your email address.',
		userName: 'Please enter your user name.',
		password: 'Please enter your password.',
		rePassword: 'Please enter your password again.',
		show: 'Read more',
		agree: 'Accept',
		signUp: 'Sign Up',
		cancel: 'Cancel',
		confirm: 'Confirm',
		success: 'Sign up is complete.',
		duplicated: 'Duplicate ID.',
		required: '(required)',
		modal: {
			title1: 'JPWORLDPAY Service Terms and Conditions',
			text1: 'These Terms and Conditions apply to all users on March 16, 2022.',
			text2: 'Welcome to JPWORLDPAY.',
			text3:
				"The service of Japan's JPWORLDPAY is provided by the national change corporation, JPWORLDPAYPte.Ltd.",
			text4:
				'JPWORLDPAYPte.Ltd. is registered with the Japan Financial Services Agency.',
			text4_1:
				"For more information on JPWORLDPAY's registration with the Financial Services Agency and",
			text5: "please visit Japan's JPWORLDPAY business.",
			text6:
				"This User Terms and Conditions regulates for the use of the Japanese customer's JPWORLDPAY account and JPWORLDPAY service.",
			text7:
				'If the customer is an individual, he must be a Japanese resident and must be 18 years of age or older in order to open a JPWORLDPAY account and use the JPWORLDPAY service.',
			text8:
				'If the customer is a business owner or a private business owner, he must be established and operated in Japan or a resident of Japan in order to open a JPWORLDPAY account and use the JPWORLDPAY service.',
			text9:
				'By opening and using a JPWORLDPAY account, you agree to comply with all of these Terms and Conditions.',
			text10:
				'You also agree to comply with each of the other terms and conditions set forth on the additional pages below,',
			text10_1: 'policies and terms and conditions pages that apply to you.',
			link1: "Japan's JPWORLDPAY services",
		},
	},
	'rtr_auth-dashboard': {
		text1: 'Popular Assets',
		text2: 'Favorite Assets',
		text3: 'You can register up to 5 favorite wallets/accounts.',
		send: 'Send',
		request: 'Request',
		history: 'Transaction details',
		greeting_message: '{user} last visit is at {date}.',
	},
	'rtr_pay-payment': {
		title1: 'Send Assets',
		title2: 'Withdrawal method',
		text1: 'Withdraw to another user',
		text2: 'Withdraw using a blockchain network',
		text3: 'Offline Store Payment (Mobile Only)',
		text4: 'Recipient account number',
		text5: 'Enter the account number.',
		text6: 'Receipt Wallet Address',
		text7: 'Enter the wallet address.',
		text8: 'Sending Quantity',
		text9: 'Offline Store Payments',
		text10: 'Remaining time',
		text11: 'Payment availability timed out.',
		text12: 'Please press the button.',
		text13: 'Reissue code',
		caution: 'Account number does not exist or is an invalid input value.',
		caution2: 'Account number does not exist or is an invalid input value.',
		recipient: 'Recipient Name',
		askWithdraw: 'Would you like to withdraw?',
		scan: 'QR Scan',
		modal: {
			success: 'The payment has been made normally.',
			recipient: 'Recipient Name',
			wallet_account: 'Wallet Address',
			payment_amount: 'Payment amount',
			check_info: 'Please check the withdrawal information.',
			account_number: 'Account number',
		},
	},
	'rtr_pay-deposit': {
		title1: 'Receive Deposit',
		title2: 'Deposit method',
		text1: 'Deposit to another user',
		text2: 'Deposit using blockchain network',
		text3: 'Invoice',
		text4: 'Account number to receive the deposit',
		text5: 'Wallet address to receive deposit',
		text6: 'There is no wallet address created.',
		text7: 'Please check the request information.',
		text8: 'Please enter an email.',
		text9: 'Please enter an item.',
		text10: 'Please enter the billing amount.',
		my_wallet: 'My Wallet Address',
		my_account: 'My account Number',
		email: '이메일을 입력해 주세요.',
		item: '품목을 입력해 주세요.',
		amount: '청구금액을 입력해 주세요.',
		success: '자산 요청이 완료되었습니다.',
	},
	'rtr_pay-exchange': {
		title1: 'Exchange',
		tab1: 'Buy',
		tab2: 'Sell',
		text1: 'Please select a crypto asset.',
		text2: 'Purchase quantity',
		text3: 'Applicable quantity',
		text4: 'Buy Fees',
		text5: 'Sell Fees',
		text6: 'Sales base rate',
		text7: 'Applied exchange rate',
		text8: 'Sales quantity',
		text9: ' Proceed?',
		text10: 'Select cryptographic asset to buy.',
		text11: 'Select cryptographic asset to pay.',
		text12: 'Select cryptographic asset to sell.',
		text13: 'Select cryptographic asset to accept payment.',
	},
	c2c: {
		buy_list: 'Buy List',
		th1: 'Sales Assets',
		th2: 'Available Quantity',
		th3: 'Price',
		th4: 'Payment Assets',
		th5: 'Status',
		status1: 'All',
		status4: 'Cancel',
		OPEN: 'Open',
		CANCELED: 'Cancel',
		COMPLETED: 'Completed',
		PENDING: 'Pending',
		PAYED: 'Holding',
		REJECTED: 'Rejected',
		CONFIRMED: 'Confirmed',
		escrow_type: {
			BOTH: 'Deposited by both Discloser and Requester',
			DEALER: 'Preferred Deposit of Disclosure of Sale',
			APPLICANT: 'Purchase Requester Preferred Deposit',
			DISABLE: 'Disable',
		},
		check: {
			title: 'New Account Registration',
			text1: 'Please add the wallet/account.',
			text2: '생성된 계좌가 없습니다.',
			text3:
				'P2P 서비스는 2개 이상의 지갑/계좌를 보유하신 고객만 이용할 수 있습니다',
		},
		search: {
			title: 'Search Cryptographic Asset',
			head1: 'All',
			head2: 'Recent',
			head3: 'Result',
			delete: 'Delete All',
			empty: 'No results',
		},
		buy: {
			title: 'Purchase Registration',
			title1: 'Precautions for purchase registration',
			head1: 'Prohibition of false holding',
			head2: 'P2P Trading',
			text1:
				'Buyers must click ‘Hold’ after payment for the P2P transaction has been completed.',
			text2:
				'JPWORLDPAY is not responsible for any disputes between sellers and buyers arising from false holdings.',
			text3:
				'Please also note that continued false holding may result in restrictions on your use of the service.',
			text4:
				'If your payment is not confirmed after completion, please contact the administrator through 1:1 inquiry.',
			text5:
				'When conducting P2P transactions through external wallets, fees may be charged, and if the P2P transaction is not completed normally, there may be inconvenience in resolving the transaction.',
			text6:
				'P2P trading is based on free trading activities between sellers and buyers.',
			text7:
				'JPWORLDPAY only provides platform services for convenient and safe transactions between sellers and buyers.',
			text8:
				'Please note that in the event of a legal dispute between the seller and buyer, JPWORLDPAY is only responsible as an escrow.',
			head3: 'Assets to be purchased',
			head4: 'Total Sales Quantity',
			head5: 'Selling price per unit',
			head6: 'Available quantity',
			head7: 'possession',
			head8: 'Purchase Quantity',
			head9: 'Fee',
			head10: 'To pay',
			head11: 'quantity',
			head12: 'Payment account',
			text9: 'The fee is',
			text10: ' deducted.',
		},
		sell: {
			title: 'Sales Registration',
			title1: 'Precautions for sales registration',
			head1: 'Prohibition of false disclosure',
			head2: 'Things to note when clicking the Confirm button',
			head3: 'If you do not press the confirm button',
			head4: 'P2P Trading',
			text1:
				'Sellers must ensure that they have sufficient crypto assets to sell before making a transaction.',
			text2:
				'Please note that if you continue to make false disclosures, your use of the service may be restricted.',
			text3:
				"The seller must confirm the buyer's payment before clicking the 'Confirm' button.",
			text4:
				"JPWORLDPAY is not legally responsible for any financial loss resulting from the seller's negligence.",
			text5: 'Be sure to check with the buyer to confirm payment.',
			text6:
				'The seller must click the ‘Confirm’ button after confirming the buyer’s payment.',
			text7:
				'Please note that if you do not click the ‘Confirm’ button, your use of the service may be restricted by the administrator.',

			text8:
				'P2P trading is based on free trading activities between sellers and buyers.',
			text9:
				'JPWORLDPAY only provides platform services for convenient and safe transactions between sellers and buyers.',
			text10:
				'Please note that in the event of a legal dispute between the seller and buyer, JPWORLDPAY is only responsible as an escrow.',
			text11: 'Fee',
			placeholder1: 'Please select a cryptographic asset to sell.',
			placeholder2: 'Please select the cryptographic asset to be paid for.',
			head5: 'Sales quantity',
			head6: 'Min quantity for order',
			head7: 'Spread Ratio',
			head8: 'Selling price per unit',
		},
	},
	'rtr_pay-contact': {
		search: 'Search',
		bookmark: 'Bookmark',
		name: 'Name',
		account: 'Account Number',
		memo: 'Memo',
		location: 'Location',
		status: 'Profile Condition',
		text1: 'Everyone has your account number',
		text2: 'jpys a search and you can deposit.',
	},
	'rtr_pay-invoice': {
		title1: 'Billing To',
		input1: 'Email',
		title2: 'Item',
		input2: 'Product Name',
		title3: 'Cryptographic assets to be received',
		title4: 'the due date of payment',
		title5: 'Total',
		text1: 'Do you want to request?',
	},
	'rtr_mypage-account': {
		title: 'Account',
		name: 'Name',
		email: 'E-mail',
		password: 'Password',
		changing_password: 'Changing password',
		new_password1: 'New password',
		new_password2: 'Confirm new password',
	},
	'rtr_mypage-data': {
		title1: 'Security',
		text1: 'Install "Google Authenticator" app on your smartphone or desktop.',
		text2:
			'Android or other systems, including iPhone, iPad, and iPod, Windows Phone, and Microsoft',
		text3: 'Windows Desktop.',
		text4: 'Please write this key ',
		text5:
			'on paper. It is used when you lose your device or need to change your OTP.',
		text6:
			'Launch the "Google Authenticator" app and tap the Scan QR barcode at the bottom of the screen.',
		text7:
			'Enter the authentication code displayed on the screen of the device in the "Authentication Code" space below.',
		text8: 'OTP key',
		text10: 'OTP key',
		text11: ' (Enter the authentication number below to activate OTP)',
		text12: 'Please enter authentication number.',
		text13: 'To disable OTP, enter the authentication number below.',
	},
	'rtr_wallet_account-assets': {
		title1: 'Asset list',
		title2: 'Wallet/Account',
		title3: 'Account registration',
		tab1: 'Assets',
		tab2: 'Bookmarks',
		empty: 'There is no selected asset.',
		text1: 'You can register up to 5 favorite wallets/accounts.',
		text2: 'Please add the wallet/account.',
		account: 'Account',
		address: 'Address',
	},
	'account-wallet': {
		title1: '나의 지갑',
		title2: '나의 계좌',
		btn_charge: 'Charging',
		btn_jpys_send: 'Make a transfer',
		btn_other_send: '출금하기',
		btn_receive: 'Deposit',
		text1: 'Payment and JPWORLDPAY can be used without JPYS.',
		my_wallet: 'My wallet address',
		my_account: 'My account number',
		btn_copy: 'Copy',
		modal: {
			title1:
				'Information on limit restrictions to prevent damage from telecommunications financial fraud',
			text1:
				'As crypto assets are opened remotely, there are limits on withdrawals (transfers) through automated machines and the Internet.',
			text2:
				'Please provide objective authentication data that can verify the purpose of the transaction.',
			text3: "You can disable the limit in 'Settings'.",
			title2: 'Note',
			text4:
				'You can apply for Internet banking by linking it on the completion screen after opening a deposit/withdrawal account.',
			caution:
				'If you want to make transfer transactions more convenient through Internet banking, you must go through security authentication. After you have upgraded your level through the authentication process, you can increase your withdrawal and transfer limits.',
			text5:
				'When you click the New Signup button, your own (cryptocurrency) JPWORLDPAY dedicated account and external wallet linked deposit address will be issued.',
			text6:
				'Please note before depositing! Transferring from JPWORLDPAY account to account may have the lowest fees or even no fees.',
			text7:
				'Only (cryptocurrency) deposits can be made to the account/wallet address issued upon new registration. Any errors/losses that may occur when attempting to deposit other digital assets to the address cannot be recovered.',
			text8:
				'After one confirmation, the deposit process will proceed and your balance will be reflected.',
			text9:
				'The deposit process is automatic and may take some time depending on network conditions. The above address is for deposits only.',
			text10:
				'You can deposit (cryptocurrency) with the new account assigned to you.',
			check1: 'Do you agree and understand the above?',
		},
	},
	rtr_activity: {
		title: 'Activity Detail',
		start: 'Start',
		end: 'Close',
		search: 'Active Search',
		button1: 'Statement',
		select: 'Please select',
		text1: "There's no transaction yet.",
		text2: 'Try again after chose the start and close date.',
		withdrawal: 'Withdrawal',
		deposit: 'Deposit',
		type: 'Type',
		registration_date: 'Registration Date',
		asset_name: 'Asset Name',
		sender: 'Sender',
		recipient: 'Recipient',
		amount: 'Transfer Amount',
		w_account: 'Withdrawal Account',
		d_account: 'Deposit Account',
		w_address: 'withdrawal wallet address',
		d_address: 'Deposit wallet address',
		detail: 'Transaction Details',
		text3: 'Sent Quantity',
		text4: 'Deposit account number',
		text5: 'Assets received',
		text6: 'Quantity received',
		text7: 'withdrawal account number',
		text8: 'Sent Assets',
		account: 'Account',
		wallet: 'Wallet',
		check_all: 'Check All',
		account_number: 'Account Number',
		empty: 'There is no registered transaction history.',
	},
	'rtr_activity-exchange': {
		title1: 'Exchange Detail',
		tab1: 'All',
		tab2: 'Buy',
		tab3: 'Sell',
		th1: 'Type',
		th2: 'Registration date',
		th3: 'Base asset quantity',
		th4: 'Relative asset quantity',
		th5: 'Applied sales base rate',
		th6: 'Applied spread rate',
		th7: 'Applied exchange rate',
		buy: 'Buy',
		sell: 'Sell',
		empty: 'There is no registered currency exchange history.',
		detail: {
			title1: 'Currency exchange details',
			th1: 'Base Assets',
			th2: 'Relative Assets',
			th3: 'Base asset quantity',
			th5: 'Base asset account number',
			th6: 'Relative asset account number',
			th10: 'Type',
			th11: 'Application date',
			th12: 'Sales asset',
			th13: 'Sales asset amount',
			th14: 'Sales asset account number',
		},
	},
	'rtr_activity-c2c': {
		title1: 'P2P Detail',
		title2: 'Purchase details',
		title3: 'Sales Status',
		title4: 'Sales Status Details',
		tab1: 'Purchase history',
		tab2: 'Sales history',
		purchased_asset: 'Purchased asset',
		purchase_quantity: 'Purchase quantity',
		purchase_price: 'Purchase price',
		payment_asset: 'Payment asset',
		total_fee: 'Total fee',
		account_number: 'Account number',
		status: 'Status',
		application_date: 'Application date',
		registration_date: 'Registration date',
		closing_date: 'Closing date',
		amount_paid: 'Amount paid',
		deposit_amount: 'Deposit amount',
		sold_asset: 'Sold asset',
		sold_quantity: 'Sold quantity',
		registered_quantity: 'Registered quantity',
		sold_price: 'Sold price',
		safety_type: 'Purchase Safety Type',
		min_purchase_quantity: 'Min purchase quantity',
		available_quantity: 'Available quantity',
		confirmed_sales_quantity: 'Confirmed sales quantity',
		unconfirmed_sales_quantity: 'Unconfirmed sales quantity',
		charge_fee: 'Sell distributor charges fees',
		empty: 'There is no registered purchase history.',
		empty2: 'There is no registered sales history.',
	},
	'rtr_activity-invoice': {
		title: 'Invoice Detail',
		target: 'Billing target',
		request_asset: 'Requested assets',
		request_amount: 'Requested amount',
		item: 'Item',
		due_date: 'Due date',
		empty: 'There is no registered invoice history.',
	},
	auth: {
		id: 'Please enter ID.',
		password: 'Please enter password.',
		login_btn: 'Login',
		signup_btn: 'Sign Up',
		or: 'or',
	},
	banner1: {
		text1: "Don't have a wallet/account?",
		text2: 'Create your JPWORLDPAY',
		text3: 'wallet/account for free now, ',
		text4: 'the safest and fastest way to make it.',
		text5: 'Make it free now!',
	},
	banner2: {
		text1: 'Service operating hours',
		text2: '(Available 24 hours)',
		text3: 'Online Bank Hours of Operation',
		text4: 'Open all year 24hours',
		text5: '(Not available 23:00 - 24:00)',
		text6: 'Offline Bank Hours of Operation',
		text7: '(Closed on weekends and holidays)',
	},
	account_register: {
		title1:
			'Information on limit restrictions to prevent damage from telecommunications financial fraud',
		text1:
			'As demand accounts are opened remotely, withdrawal (transfer) limits through automated teller machines and the Internet are limited to a certain amount per day.',
		text2:
			'You can present objective authentication data that can verify the purpose of the transaction to the branch and lift the limit restriction in “Management > Security Authentication/Management.”',
		text3:
			'When using Internet banking, you must register a withdrawal account to make a transfer transaction.',
		text4: 'Only 5 accounts can be opened per person per cryptocurrency.',
		title2: 'Note',
		text5:
			'- You can apply for Internet banking by linking it on the completion screen after opening a deposit/withdrawal account.',
		text6:
			'- Please note that existing Internet Banking subscribers can only register a withdrawal account through Internet Banking if the withdrawal account registration category is set to Internet + Branch.',
		text7:
			'* To make transfer transactions more convenient through Internet banking, you must go through security authentication. After improving your level through the authentication process, please increase your withdrawal and transfer limits.',
		title3:
			'When you click the New Signup button, your unique {title} JPWORLDPAY dedicated account and external wallet linked deposit address will be issued.',
		text8:
			'Please note before depositing! Transferring from JPWORLDPAY account to account may have the lowest fees or even no fees.',
		text9:
			'Only {title} deposits can be made to the account/wallet address issued upon new registration.',
		text10:
			'Any errors/losses that may occur when attempting to deposit other digital assets to that address are irrecoverable.',
		text11:
			'After one confirmation, the deposit process will proceed and your balance will be reflected.',
		text12:
			'The deposit process is automatic and may take some time depending on network conditions. The above address is for deposits only.',
		text13: 'You can deposit { title } with the new account assigned to you.',
		agree: 'Do you agree and understand the above?',
		title4: 'Account Unique Number',
		title5: 'account number',
		title6: 'Account name',
		text14: 'Please enter your account name.',
		title7: 'Stop amount',
		title8: 'Condition',
		title9: 'Selected Assets',
		text15: 'It will be entered automatically.',
		title10: 'Generated account number',
		text16: 'JPWORLDPAY dedicated account number',
	},
	merchant: {
		picker: {
			title1: 'Select store to manage.',
			title2: 'Store Registration',
			success_shop_register: 'The Merchant has been registered.',
			insert_shop_name: 'Please enter the Merchant name.',
			insert_shop_id: 'Please enter the Merchant ID.',
			merchant_name: 'Merchant Name',
			merchant_id: 'Merchant ID',
			regist_date: 'Registration Date',
		},
		transaction: {
			text1: 'Payment History',
			text2: "There's no transaction yet.",
			text3: 'Try again after chose the start and close date.',
			text4: 'Payment detail',
			empty: 'There are no registered payment details.',
			total_count: 'Total',
			total_amount: 'ToTal Amount',
			count: ' thing',
			table: {
				time: 'Payment Date',
				name: 'Payment Items',
				id: 'Payment ID',
				payer: 'Payer Name',
				type: 'Payment Type',
				status: 'Condition',
				amount: 'Payment Amount',
				order_no: 'Store Order Number',
			},
		},
		settlement: {
			title: 'List of settlement accounts',
			title1: 'Settlement Account Connect',
			title2: 'Settlement Account disconnect',
			date: 'Registration Date',
			asset_name: 'Assets Name',
			account: 'Account Number',
			no_content: 'No articles registered',
			select: 'Please select a cryptographic asset.',
			name: 'Merchant Name',
			id: 'Merchant ID',
			asset: 'Settlement Account',
			connect: 'Settlement Account Connect',
			disconnect: 'Disconnect',
			set_disconnect: 'Disconnect Settlement Account',
			disconnect2: 'Settlement account connection has been terminated.',
		},
		title1: 'Transaction Statistics',
		title2: 'A Settlement Calendar',
		title3: 'Quick menu',
		title4: 'Notice',
		title5: 'Customer Service',
		title6: 'Managing Authentication',
		menu1: 'Store Information',
		menu2: 'List of settlement accounts',
		menu3: 'Individual inquiry',
		menu4: 'Inquiries',
		menu5: 'Email Authentication',
		menu6: 'OTP Authentication',
		menu7: 'Security level',
		menu_2: {
			menu1: 'Notice',
			menu2: 'Individual inquiry',
			menu3: 'Inquiries',
			menu4: 'Frequently Asked Questions',
			menu5: 'KYC Authentication',
			menu6: 'Email Authentication',
			menu7: 'OTP Authentication',
			menu8: 'Withdrawal Address Authentication',
			menu9: 'Security level',
		},
		inquiry: {
			text1: 'Please select inquiry type.',
			text2: 'Please enter the title.',
			text3: 'Please write your inquiry.',
			text4: 'Inquiry Type',
			text5: 'Title',
			text6: 'Registration date',
			text7: 'Condition',
			text8: 'Waiting for response',
			text9: 'Response complete',
			text10: 'There is no registered content.',
			text11: '문의 작성하신 내용이',
			text12: '정상적으로 접수 완료',
			text13: '되었습니다.',
		},
		kyc: {
			text1: '회원 고유 번호',
			text2: '사용자 이름',
			text3: '이메일',
		},
		email: {
			link1: 'Resend Authentication Code',
		},
		otp: {
			text1:
				'Install "Google Authenticator" app on your smartphone or desktop.',
			text2:
				'Android or other systems, including iPhone, iPad, and iPod, Windows Phone, and Microsoft Windows Desktop.',
			text3: 'Please write this key,',
			text4:
				'on paper. It is used when you lose your device or need to change your OTP.',
			text5:
				'Launch the "Google Authenticator" app and tap the Scan QR barcode at the bottom of the screen.',
			text6:
				'Enter the authentication code displayed on the screen of the device in the "Authentication Code" space below.',
			text7: 'OTP key',
			text8: 'OTP key (Enter the authentication number below to activate OTP)',
			text9: 'Enter verification number.',
		},
		address: {
			select: '선택없음',
			text1: 'Select assets',
			text2: 'Assets Address',
			text3: 'Please write the assets address',
			text4: '이미 인증이 완료된 자산입니다.',
			text5: '뱅크 선택',
			text6: '예금주 명',
			text7: 'Account Number',
			text8: '생일',
			text9: '생년월일 6자리',
			register: 'Registeration',
			alert: '출금주소 인증이 완료되었습니다.',
		},
		security: {
			authStatus: {
				ok: 'Authentication complete',
				no: '인증하기',
			},
			level1: 'Level 1',
			level2: 'Level 2',
			level3: 'Level 3',
			level4: 'Level 4',
			email: 'Email Authentication',
			kyc: 'KYC Authentication',
			otp: 'OTP Authentication',
			address: 'Withdrawal Address Authentication',
			title1: '회원고유번호',
			title2: '유저명',
			title3: 'Restrictions',
			text1: 'Limit on asset amount per withdrawal 100 ETH',
			text2: '100 ETH',
			text3: 'Limit on asset amount per day 1,000 ETH',
			text4: '1,000 ETH',
			text5: 'Limit on asset amount per withdrawal 10 BTC',
			text6: '10 BTC',
			text7: 'Limit on asset amount per day 1,000 BTC',
			text8: '1,000 BTC',
			placeholder: 'Please write the e-mail address.',
			placeholder1: '인증코드를 5분 이내에 입력해 주세요.',
		},
		info1: ' is',
		info2: 'Level ',
		info3: 'The security level of.',
	},
	input: {
		placeholder: {
			search: 'search',
			select_assets: 'Please select a asset.',
			search_assets: 'Please search a asset.',
			search_activity: 'Active Search',
			email: 'please enter your e-mail address.',
			code_request: 'Please enter the verification code.',
			inquiry_type: 'Please select inquiry type.',
			enter_subject: 'Please enter the title.',
			inquiry_content: 'Please write your inquiry.',
			password: 'Please enter your password.',
			all_assets: 'All assets',
		},
		label: {
			email: 'E-mail',
			password: 'Password',
			inquiry_type: 'Inquiry Type',
			enter_subject: 'Title',
			inquiry_content: 'Inquiry',
		},
	},
	select: {
		select: 'Please Select.',
		all: 'All',
	},
	button: {
		add: 'Add',
		delete: 'Delete',
		cancel: 'Cancel',
		change: 'Change',
		pay: 'Make a Payment',
		next: 'Next',
		back: 'Back',
		request: 'Request',
		send: 'Send',
		close: 'Close',
		do_not_look: '다시보지않기',
		confirm: 'Confirm',
		signup: 'Sign Up',
		down: 'Download App',
		edit: 'Edit',
		edit1: 'Editing',
		delete_account: '계정 탈퇴',
		code: 'Send Verification Code',
		code_check: 'Confirm Code',
		code_completed: '인증 완료',
		otp: 'Activate OTP',
		otp_disabled: 'OTP Deactivate',
		asset_send: 'Send Asset',
		cryptocurrency_request: 'Cryptocurrency Request',
		membership_withdrawal: 'Membership Withdrawal',
		info: 'Contact Sales Department',
		share: 'Share',
		new_account: 'Open Account',
		open_account: 'Open',
		search: 'Search',
		start: 'Getting Started',
		register: 'Registration',
		list: 'List',
		inquiry_list: 'To Inquiry',
		exchange: 'Exchange Money',
		check_balance: 'Check Balance',
		sales: 'Sales Registration',
		purchase: 'Purchase Registration',
		withdraw: 'Withdraw',
		copy: 'Copy',
		detail: 'Detail',
		payment: 'Payment',
		decide: 'Decide',
		check: 'Check',
		reject: 'Reject',
		application: 'Application',
		connect: 'Connect',
		not_see_today: 'Do not show today',
		receive_request: 'Request to receive',
		block: 'Block',
		more: 'More',
	},
	modal: {
		message: {
			select_asset: 'Please select the assets.',
			select_way: 'Please select a withdrawal method.',
			check_account: "Please check the recipient's account.",
			check_address: "Please check the recipient's address.",
			set_amount: 'Please enter the transfer amount.',
			need_agree: 'You can sign up for a new one only if you agree.',
			success_exchange:
				'The currency exchange has been processed successfully.',
			no_account: 'No account has been opened.',
			set_otp: 'OTP activation is complete.',
			deactivation_otp: 'OTP deactivation is complete.',
			set_code: 'Please enter a certification number.',
			set_buy: 'Would you like to purchase it?',
			registered: 'Has been registered.',
			set_sell: 'Would you like to sell it?',
			success_withdraw: 'The withdrawal has been completed.',
			success_confirm: 'The confirmation was successfully processed.',
			success_cancel: 'The Cancellation was successfully processed.',
			success_payment: 'The payment was successfully processed.',
			success_reject: 'The reject was successfully processed.',
			set_cancel: 'Would you like to cancel?',
			set_pay: 'Would you like to pay?',
			set_confirm: 'Would you like to confirm?',
			set_reject: 'Would you like to reject?',
			sent_id: 'The ID has been sent to your email.',
			sent_authCode: 'The Auth code has been sent to your email.',
			pw_changed: 'Password has been changed.',
			settlement_connect: 'The settlement account has been connected.',
			settlement_disconnect:
				'Are you sure you want to close your settlement account?',
			settlement_disconnect2: 'The settlement account has been disconnected.',
			merchant_regist_confirm: 'The merchant registration has been completed.',
			complete_payment: 'The payment has been completed.',
		},
		account: {
			status1: '변경 할 항목을 입력해주세요.',
			status2: 'Your account information has changed.',
			status3: 'Your membership withdrawal has been completed.',
			status4: 'Are you sure you want to delete your account?',
			status5: '회원 이름을 입력해주세요.',
			status6: 'Please enter your password.',
			status7: '새 비밀번호를 입력해주세요.',
			status8: '새 비밀번호 확인을 입력해주세요.',
			status9: '새 비밀번호와 비밀변호 확인이 일치하지 않습니다.',
		},
		history: 'Transfer details',
	},
	alert: {
		request_id: 'Please enter ID.',
		request_pw: 'Please enter password.',
		request_check_term: 'Please accept the required terms and conditions.',
		transaction_check: 'Please check the transaction details.',
		not_yet: 'Coming soon.',
		copy_s: 'It has been copied.',
		copy_f: 'Copy failed.',
		logout: 'Do you want to log out?',
		enter_email: 'Please enter email address.',
		enter_authCode: 'Please enter auth code.',
		enter_newPw: 'Please enter new password.',
		enter_newPwConfirm: 'Please enter new password confirm.',
		wrong_newInfo: 'New password and password verification do not match.',
	},
	help: {
		title: 'Help',
		title1: 'General Questions',
		q1: 'Activity not displayed',
		a1: "If you don't see your search history, websites you visit, or other activities in My Activities, please check the following:",
		q2: 'Unknown activity exists',
		a2: 'My Activity might display an unknown type of activity:',
		q3: 'Review recommendation settings for privacy',
		a3: 'You can set the Auto Delete option to manage the activity retention period.',
		q4: 'To verify your privacy settings',
		a4: 'Privacy diagnostics make it easy to view and change most of the settings described below.',
		q5: 'To control which activities to save',
		a5: 'In Activity Control Settings, you can select the type of activity that is stored in your account. The following activities are included:',
		q6: 'To track and delete information',
		a6: 'The following resources help you review and control the activities stored on your Google Account.',
		q7: 'To view a data overview',
		a7: 'Visit the Google Dashboard for a summary of data from several Google services, including Gmail, Drive, and Calendar.',
		q8: 'To view and delete activities/files',
		a8: 'You can view and delete files such as photos, emails, and documents from the following relevant Google products:',
		q9: 'My activities',
		a9: 'Under My Activities, check and delete activities such as search history and websites you visit.',
		q10: 'To view and delete places you have visited',
		a10: "When you enable Location History, the places you visit are saved in your account. I'm the only one who can see my location record.",
		q11: 'Additional Information',
		a11: 'Learn more about my data and how Google uses my data in the following resources:',
		q12: 'To change the activity that is',
		a12: 'You can change this setting to control most of the activities stored in your account.',
		q13: 'To view or delete an activity',
		a13: 'Go to your Google Account.',
		q14: 'If the activity is saved',
		a14: 'Your activity will be saved when you log in to your Google account on your mobile phone. Google can save information based on this setting if Activity Control is enabled.',
		q15: 'To delete an activity',
		a15: 'If you delete an activity manually or automatically delete it according to the Auto Delete setting, the deletion procedure will begin immediately on the product and Google System.',
		q16: 'What is my activity?',
		a16: 'My activities are places where I can check and manage activities such as searches, websites I visited, and videos I watched.',
		q17: 'Find and view activities',
		a17: 'My activities are listed as individual items, starting with the most recent activities.',
		q18: 'Deleting an Activity',
		a18: 'Learn how to delete historical search history, visit history, and other activities from My Activities. You can also set the previous activity to be automatically deleted.',
		q19: 'Accessing data from administrators or service providers',
		a19: 'Owner of data or content submitted or uploaded through an account',
		q20: 'Resolving SafeSearch Issues',
		a20: "If Safe Search doesn't work, find out how to solve the Safe Search problem.",
		q21: 'Reporting sensational content',
		a21: 'If you find sensational content while using SafeSearch, please report it.',
	},
	popup: {
		title1: 'Close beta test ',
		title2: 'JPWORLDPAY supporters',
		title3: ' Recruiting!',
		period: 'Close Beta Period 2022/11/23 ~ 12/23',
		text1:
			'We invite JPWORLDPAY supporters to the close beta test of JPWORLDPAY.',
		text2:
			'The PAY platform based on blockchain, the first service of JPWORLDPAY',
		text3: 'Please check out JPWORLDPAY in advance.',
		m_text1: 'Welcome to the JPWORLDPAY',
		m_text2: 'Close Beta Test.',
		m_text3: 'Close beta period',
		m_text4: '2022/11/23',
		m_text5: '~12/23',
	},
	tutorial: {
		dashboard: {
			step1_title: '인기자산',
			step1_text: 'JPWORLDPAY에서 추천하는 인기 자산입니다.',
			step2_title: '보내기',
			step2_text: '버튼을 탭(터치)해서 자산을 보내세요.',
			step3_title: '요청하기',
			step3_text: '버튼을 탭(터치)해서 자산을 요청하세요.',
			step4_title: '거래내역',
			step4_text: '자산을 보내고 받은 내역을 확인하세요.',
			step5_title: '즐겨찾는 지갑/계좌',
			step5_text:
				'다음 아이콘과 동일한 버튼을 탭(터치)하면 즐겨찾는 자산을 설정할 수 있어요.',
			step6_title: '지갑/계좌 만들기',
			step6_text: '다양한 자산을 추가해서 더 많은 서비스를 경험하세요.',
		},
		payment: {
			step1_title: '보내는 자산',
			step1_text: '보낼 수 있는 자산을 확인하고 선택하세요.',
			step2_title: '보내는 방식',
			step2_text: '세가지 방식으로 자산을 보낼 수 있습니다.',
			step3_title: '1. 오프라인 상점 결제',
			step3_text: 'JPWORLDPAY 가맹점에서 QR코드로 간편하게 결제하세요.',
			step4_title: '2. 계좌 번호로 출금',
			step4_text: 'JPWORLDPAY 사용자에게 계좌 번호로 자산을 보내세요.',
			step5_title: '3. 지갑 주소로 출금',
			step5_text: '지갑 주소로 JPYS와 암호자산을 보내세요.',
		},
		deposit: {
			step1_title: '요청하는 자산',
			step1_text: '요청할 수 있는 자산을 확인하고 선택하세요.',
			step2_title: '요청하는 방식',
			step2_text: '세가지 방식으로 자산을 요청할 수 있습니다.',
			step3_title: '1. 계좌 번호로 입금',
			step3_text: 'JPWORLDPAY 사용자에게 계좌 번호로 자산을 요청하세요.',
			step4_title: '2. 지갑 주소로 입금',
			step4_text: '지갑 주소로 자산을 요청하세요.',
			step5_title: '3. 인보이스',
			step5_text: '청구서를 보내 자산을 요청하세요.',
		},
		exchange: {
			step1_title: '구매/판매',
			step1_text: 'JPWORLDPAY에서 제안하는 환전 방식으로 자산을 교환하세요.',
		},
		c2c: {
			step1_title: '판매등록',
			step1_text: '다른 JPWORLDPAY 사용자에게 내가 가진 자산을 판매하세요.',
			step2_title: '목록 갱신',
			step2_text:
				'아이콘 버튼을 탭(터치)해서 현재 판매중인 모든 목록을 확인하세요.',
			step3_title: '구매 신청',
			step3_text: '원하는 판매건을 선택해서 구매를 신청하세요.',
		},
	},
	underConstruction: 'coming soon',
	menu: {
		dashboard: 'Dashboard',
		company: '기업',
		personal: 'Individual',
		'personal-how': 'How to Shop and Buy',
		'personal-how-online_shopping': 'Online Shopping',
		'personal-how-offline_kiosk': 'Offline Kiosk',
		'personal-how-qr': 'Pay with QR Code',
		'personal-how-janopay_creditcard': 'JPWORLDPAY credit card',
		'personal-how-trade_and_cashback': 'Transaction and Cashback',
		'personal-request': 'Send and Receive',
		'personal-request-send': 'Send Asset',
		'personal-request-receive': 'Asset Request',
		'personal-request-deposit': 'Get a deposit',
		'personal-request-commission': 'Fee',
		'personal-asset': 'Asset Management',
		'personal-asset-wallet': 'Wallet',
		'personal-asset-account': 'Account',
		'personal-asset-jpys': 'Add JPYS',
		'personal-asset-sale': 'Sell',
		'personal-asset-exchange': 'Exchanging Currency',
		business: 'Business',
		'business-how': 'Starting method',
		'business-how-start': 'Getting Started',
		'business-how-solution': 'Solution',
		'business-how-receive': 'Accepting Payment',
		'business-how-pay': 'Make a Payment',
		'business-how-risk': 'Risk Management',
		'business-operation': 'Management Method',
		'business-operation-corps': 'About Company',
		'business-operation-platform': 'Platforms and Features',
		'business-operation-pay': 'Payment Method',
		'business-operation-global': 'Global Payment Processing',
		'business-asset': 'Asset Management',
		'business-asset-pay': 'Payment Method',
		'merchant-console-catalog': 'Store Information',
		'merchant-console-transaction-list': 'Payment History',
		'merchant-console-settlement_account': 'List of settlement accounts',
		'merchant-console-cs-notice': 'Customer Service',
		'merchant-console-certification-kyc': 'Managing Authentication',
		development: 'Development',
		cs: 'Customer Service',
		notice: 'Notice',
		inquiry: 'Individual inquiry',
		inquiry_detail: 'Inquiries',
		faq: 'Frequently Asked Questions',
		pay: 'Asset Management',
		'pay-payment': 'Send Asset',
		'pay-deposit': 'Receive Deposit',
		'pay-exchange': 'Exchange',
		'pay-c2c': 'P2P',
		'pay-contacts': 'Contact Information',
		'pay-invoice': 'Invoice',
		wallet_account: 'Wallet/Account',
		'wallet_account-wallet': '지갑열기',
		'wallet_account-account': '계좌열기',
		'wallet_account-assets': '전체자산',
		activity: 'Activity Details',
		'activity-transaction': 'Transaction Details',
		'activity-exchange': 'Exchange Detail',
		'activity-c2c': 'P2P Detail',
		'activity-invoice': 'Invoice Detail',
		help: 'Help',
		setting: 'Setting',
		'setting-security': 'Security',
		'setting-payment': 'Make a payment',
		'setting-notice': 'Notice',
		mypage: 'Mypage',
		merchant: {
			merchant: 'Merchant',
			personal: 'Individual',
			information: 'Information',
			payment_history: 'Payment history',
		},
		'mypage-account': 'Account',
		'mypage-data': 'Data',
		'mypage-certification': 'Certification / Management',
		'mypage-seller_tool': 'Seller Tools',
		logout: 'Logout',
		login_text1: 'Please log in to view',
		login_text2: 'more information.',
	},
	// rtr_activity,
	merchant_management: {
		menu: 'Menu',
		title: {
			qr_payment: 'Qr Scan',
			payment_list: 'Payment List',
			merchant_management: 'Merchant Management',
			account: 'Account',
			setup: 'Setup',
		},
		merchant_list: 's List of franchises',
		account_number: 'Account number',
		qr_payment: {
			deal_name: 'Transaction name',
			title: 'QR Payment',
			payer: 'Payer',
			check_payment_information: 'Check the payment information.',
			payment: 'Payment',
			complete_payment: 'The payment has been completed.',
			payment_asset: 'Payment asset',
			payment_name: 'Payment name',
			amount: 'Payment amount',
		},
		payment_list: {
			login: 'Login',
			forgot: 'Find ID/password',
			qr_scan: 'Please scan the QR code.',
			merchant_selection: 'Select Merchant',
			count: ' thing',
			order_number: 'Order number',
			detail: {
				total_payment: 'Total',
				total_amount: 'Total Amount',
				complete_payment: 'Payment completed',
				refund: 'Refund',
				no_payment_count: '해당 날짜의 결제건이 없습니다.',
				merchant_name: 'Merchant Name',
				payment_assets: 'Payment Asset',
				payment_date: 'Payment Date',
				refund_date: 'Refund Date',
				check_refund_information: '환불 정보를 확인 해 주세요.',
				refund_complete: '환불이 완료되었습니다.',
			},
			table: {
				time: 'Payment Date',
				name: 'Payment Items',
				id: 'Payment ID',
				payer: 'Payer Name',
				type: 'Payment Type',
				status: 'Condition',
				amount: 'Payment Amount',
				oder_no: 'Store Order Number',
			},
			modal: {
				title: 'Detailed search',
				date1: 'Today',
				date2: 'Yesterday',
				date3: '1m',
				date4: '3m',
				date5: '6m',
			},
		},
		setup: {
			language: 'Language',
			terms: 'Terms',
			push_notification: 'Push alarm',
		},
	},

	// new UI translation
	new_ui: new_ui.en_US,
};
